export declare class CourseEntity {
  public id: number;
}
